export const WaveLinesBottom = () => (
  <svg
    viewBox="0 0 979 758"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      position: "absolute",
      width: "130%",
      height: "130%",
      left: "-20%",
      top: "25%",
      transform: "rotate(180deg)",
      transformOrigin: "center",
    }}
  >
    <path
      d="M159.893 24.8958C159.893 24.8958 167.813 22.5189 172.383 15.584C176.973 8.59157 185.401 6.07497 185.401 6.07497"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M152.292 45.5943C152.292 45.5943 175.973 46.8518 187.667 32.4196C198.962 18.363 223.197 19.8891 223.197 19.8891"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M144.691 66.2928C144.691 66.2928 184.133 71.1848 202.873 49.2917C220.988 28.213 260.971 33.7608 260.971 33.7608"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M137.07 87.0488C137.07 87.0488 192.235 95.4965 218.137 66.1848C242.899 38.0208 298.746 47.6323 298.746 47.6323"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M129.469 107.747C129.469 107.747 200.395 119.829 233.343 83.0569C264.889 47.7922 336.464 61.4829 336.464 61.4829"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M121.847 128.503C121.847 128.503 208.533 144.22 248.606 99.9501C286.914 57.6423 374.238 75.3545 374.238 75.3545"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M114.246 149.202C114.246 149.202 216.657 168.474 263.812 116.822C308.825 67.4501 411.956 89.2051 411.956 89.2051"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M106.645 169.9C106.645 169.9 224.816 192.807 279.097 133.658C330.872 77.2426 449.788 103.098 449.788 103.098"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M99.0228 190.656C99.0228 190.656 232.955 217.198 294.339 150.608C352.84 87.0715 487.563 116.969 487.563 116.969"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M91.4218 211.355C91.4218 211.355 241.057 241.509 309.566 167.423C374.809 96.9005 525.338 130.841 525.338 130.841"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M83.8209 232.053C83.8209 232.053 249.238 265.785 324.83 184.316C396.798 106.672 563.055 144.692 563.055 144.692"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M76.199 252.809C76.199 252.809 257.377 290.175 340.036 201.188C418.767 116.501 600.83 158.563 600.83 158.563"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M68.598 273.508C68.598 273.508 265.479 314.487 355.299 218.081C440.756 126.272 638.604 172.435 638.604 172.435"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M60.997 294.206C60.997 294.206 273.639 338.82 370.505 234.953C462.724 136.101 676.379 186.307 676.379 186.307"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M53.3752 314.963C53.3752 314.963 281.799 363.153 385.769 251.847C484.693 145.93 714.097 200.157 714.097 200.157"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M45.7743 335.661C45.7743 335.661 289.901 387.465 400.975 268.719C506.682 155.702 751.871 214.029 751.871 214.029"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M38.1732 356.36C38.1732 356.36 298.061 411.798 416.259 285.554C528.65 165.531 789.646 227.9 789.646 227.9"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M30.5513 377.116C30.5513 377.116 306.221 436.131 431.502 302.505C550.619 175.359 827.421 241.772 827.421 241.772"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M22.9503 397.814C22.9503 397.814 314.323 460.442 446.729 319.32C572.608 185.131 865.196 255.644 865.196 255.644"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M15.3494 418.513C15.3494 418.513 322.483 484.775 461.992 336.213C594.576 194.96 902.913 269.494 902.913 269.494"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M7.72748 439.269C7.72748 439.269 330.621 509.166 477.198 353.085C616.602 204.81 940.688 283.366 940.688 283.366"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
    <path
      d="M0.126462 459.967C0.126462 459.967 338.745 533.42 492.462 369.978C638.592 214.581 978.463 297.237 978.463 297.237"
      stroke="#F7F4FF"
      stroke-width="1.225"
      stroke-miterlimit="10"
    />
  </svg>
);
